import { useSelector } from 'react-redux'
import useIsEmployeeOrg from 'hooks/useIsEmployeeOrg'

const usePermissions = () => {
  const isEmployeeOrg = useIsEmployeeOrg()
  const { is_super_admin, permission_details } = useSelector(({ auth }) => auth.employee)
  const { company } = useSelector(({ auth }) => auth)
  const { showOpenApi, showWebhook } = useSelector(({ enablerDataReducer }) => enablerDataReducer)

  const isPerformanceSupport =
    company?.subscribed_features?.includes('performance_management') && isEmployeeOrg
  const is_jisr_pay_enabled = useSelector((s) => s.auth.employee?.organization.jisrpay_enabled)

  const isGlSupported = company?.subscribed_features?.includes('gl_accounting')
  const allowOpenApiGeneration = company?.subscribed_features?.includes('open_api')
  const isAnalysis = company?.subscribed_features?.includes('analytics')
  const isAutomationSupported = company?.subscribed_features?.includes('automation_workflow')
  const isMultiSubSupported = company?.subscribed_features?.includes('multi_subsidiaries')
  const isSuperAdmin = is_super_admin
  const canManageBulkImportSheets =
    !!permission_details.bulk_update_employee_information ||
    !!permission_details.add_new_employees ||
    !!permission_details.manage_salary_information ||
    !!permission_details.manage_personal_and_organization_information ||
    !!permission_details.manage_assets ||
    !!permission_details.manage_other_financial_information ||
    !!permission_details.manage_loans ||
    !!permission_details.bulk_update_leave_balance ||
    !!permission_details.bulk_edit_attendance_records ||
    !!permission_details.bulk_edit_approved_overtime_sheet ||
    !!permission_details.edit_on_payroll_table ||
    !!permission_details.manage_shifts_and_working_hours

  return {
    ...permission_details,
    canManageBulkImportSheets,
    isPerformanceSupport,
    is_jisr_pay_enabled,
    isGlSupported,
    allowOpenApiGeneration,
    isSuperAdmin,
    showOpenApi,
    showWebhook,
    isAnalysis,
    isAutomationSupported,
    isMultiSubSupported,
  }
}

export default usePermissions
